import React from 'react';
import {connect} from 'dva';
import {framework_tool, component_tool} from '@/tool'
import {templateConfig, reduxTemplateConfig} from './config'
import {certStageExcelColumns} from './excelColumns';

const {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;
let {WizBrowserExport} = component_tool;

class CertStageList extends WizContainer {
  componentName = 'certStageList';

  constructor(props) {
    super(props);
    this.state = {
      AddTimestamp: new Date().getTime()
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]

    if (o['success']) {
      let data = o['data']
      WizBrowserExport({
        title: '证书路径阶段配置信息',
        sheetName: '证书路径阶段配置信息',
        columns: certStageExcelColumns.filter((_, index) => index),
        rows: data,
        filename: '证书路径阶段配置信息.xlsx',
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _templateConfig = templateConfig(this)
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        export:this._handleFile,
      },
    });
    return <WizReduxTemplate {..._reduxTemplateConfig} />
  }


}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(CertStageList);
